const tokens = {
  colors: {
    primary: {
      50: '#e6f9fc',
      100: '#b3eef5',
      200: '#80e3ee',
      300: '#4dd8e7',
      400: '#26d0e2',
      500: '#00bed8',
      600: '#00a8bf',
      700: '#009bb0',
      800: '#007a8a',
      900: '#005c68',
    },
    neutral: {
      0: '#ffffff',
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    },
    semantic: {
      success: '#10b981',
      warning: '#f59e0b',
      error: '#ef4444',
      info: '#3b82f6',
    },
  },

  typography: {
    fontFamily: {
      primary: "'Pretendard-Regular', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      light: "'Pretendard-Light', sans-serif",
      medium: "'Pretendard-Medium', sans-serif",
      semibold: "'Pretendard-SemiBold', sans-serif",
      bold: "'Pretendard-ExtraBold', sans-serif",
      mono: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
    },
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      '2xl': '1.5rem',
      '3xl': '1.875rem',
      '4xl': '2.25rem',
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    },
  },

  spacing: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    8: '2rem',
    10: '2.5rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
  },

  elevation: {
    none: 'none',
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
    base: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04)',
  },

  borderRadius: {
    none: '0',
    sm: '4px',
    base: '8px',
    md: '10px',
    lg: '16px',
    xl: '24px',
    full: '9999px',
  },

  breakpoints: {
    mobile: '500px',
    tablet: '768px',
    laptop: '1024px',
    desktop: '1200px',
  },

  layout: {
    maxWidth: '1200px',
    headerHeight: '80px',
    footerMinHeight: '10vh',
  },

  transition: {
    fast: '0.15s ease',
    base: '0.2s ease-in-out',
    slow: '0.3s ease-in-out',
  },

  zIndex: {
    dropdown: 10,
    sticky: 20,
    fixed: 30,
    modal: 40,
    popover: 50,
    tooltip: 60,
  },
};

export default tokens;
